import { HttpInterceptorFn, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const ngrokWarningInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (environment.build !== 'pre') {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'ngrok-skip-browser-warning': '1',
      },
    }),
  );
};
